{
  "header": {
    "id": "ID",
    "firstname": "Firstname",
    "lastname": "Lastname",
    "profile": "Profile",
    "profiles": "Profiles",
    "email": "Email",
    "description": "Description",
    "sector": "Sector",
    "sectors": "Sectors",
    "group": "Group",
    "groups": "Groups",
    "user": "User",
    "users": "Users",
    "application": "Application",
    "applications": "Applications",
    "equipment": "Device",
    "equipments": "Devices",
    "label": "Name",
    "nbUsers": "Number of users",
    "userGroup": "Group",
    "userGroups": "Groups",
    "device": "Device",
    "devices": "Devices"
  }
}
